import React, { useState } from 'react';
import {
    Button,
    Col,
    Row,
    Input,
    Slider,
    Card,
    Toast,
    Spinner
} from '@kaleyra/emmy';
import Styles from '../SubAccounts.module.scss';
import { useSelector } from 'react-redux';
import { IStateType } from '../../../../store/models/root.interface';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '../../../../assets/error.svg';
import { useHistory } from 'react-router-dom';

export type MapStatePropsType = {
    sidebarVisibility: any;
    params: any;
};

export type DispatchPropsType = {
    onClose: () => void;
    rechargeSubaccount: (data: any, callBack: any) => void;
    balanceApi: () => void;
    onLoad: () => void;
};

const RechargeSubAccount: React.FC<MapStatePropsType & DispatchPropsType> = ({
    onClose,
    rechargeSubaccount,
    balanceApi,
    onLoad,
    params,
    sidebarVisibility,
}) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { base_currency_symbol: parentCurrencySymbol, value_in_base_currency: parentBalance } = useSelector((state: IStateType) => state.balance?.fullBalanceObject);
    const parentBillingType = useSelector((state: IStateType) => state.balance?.fullBalanceObject?.billing_type?.label);
    const [creditAmount, setCreditAmount] = useState('')
    const [creditAmountErr, setCreditAmountErr] = useState('');
    const [saving, setSaving] = useState(false)

    const checkSaveButtonEnable = () => {
        if (validateCheck('creditAmount') || saving)
            return true
        return false
    }

    const handleOnSave = () => {
        setSaving(true)
        rechargeSubaccount(({
            subaccount_id: params.subaccountCompanyId,
            amount: parseFloat(creditAmount),
        }), (res: any, success: boolean) => {
            if (success) {
                setSaving(false)
                Toast(t("KLR02580"), "success");
                onClose()
                onLoad()
                balanceApi()
            }
            else {
                setSaving(false)
                Toast(res?.data?.error?.data?.message || t("KLR02515"), "error")
            }
        })
    }

    const getFooter = (): React.ReactNode => {
        return (
            <div className={Styles.footer}>
                <Button type="tertiary" onClick={onClose}>
                    {t("mainCancel")}
                </Button>
                <Button
                    className={Styles.addamount}
                    disabled={checkSaveButtonEnable()}
                    onClick={() => handleOnSave()}
                >{saving ? <Spinner margin={"2rem"} /> : t("KLR02540")}
                </Button>
            </div>
        );
    }

    const validateCheck = (field: string) => {
        let amount = parseFloat(creditAmount)
        let decimalAmount: any = creditAmount.split('.')[1]

        if (field === 'creditAmount') {
            if (creditAmount.trim() === '') {
                return t('titleReq');
            }
            if (amount > parentBalance) {
                if (parentBillingType === 'postpaid') {
                    return t("KLR02574",{'parentBalance':Number(parentBalance) ,'symbol':parentCurrencySymbol})
                }
                return t("KLR02539");
            }
            if (amount < 0 && params.balance < Math.abs(amount)) {
                return t("KLR02573")
            }

            if (amount === 0 || isNaN(Number(creditAmount))) {
                return t("KLR02572")
            }
            if (decimalAmount) {
                if (decimalAmount.length > 2)
                    return t("KLR02582")
            }
            return;
        }
    }

    const handleCreditAmountOnBlur = () => {
        let errMsg = validateCheck('creditAmount')
        if (errMsg) {
            setCreditAmountErr(errMsg);
            return;
        } else {
            setCreditAmountErr('');
            return;
        }
    }

    const validateFields = (field: string): 'error' | undefined => {
        if (validateCheck(field)) {
            return "error";
        }
        return undefined;
    }

    const setErrors = (field: string) => {
        let errMsg = validateCheck(field);
        if (errMsg) {
            return (
                <div>
                    <img
                        src={ErrorIcon}
                        alt=""
                        className={Styles.errorIcon}
                    />
                    {errMsg}
                </div>
            );
        }
    }
   
    const getContent = () => {
        return (
            <>
                <div className={Styles.rechargeamount}>
                    <Card style={{ paddingBottom: 2, paddingTop: 16 }} showHoverBorder={false}>
                        <Row>
                            <Col size={7}>
                                <p className={Styles.availablebalance}>{t("KLR02541")}</p>
                            </Col>
                            <Col size={5}>
                                <p className={Styles.params}>{`${parentCurrencySymbol}${parseFloat(params.balance).toFixed(2)}`}</p>
                            </Col>
                        </Row>
                    </Card>
                    <div className={Styles.rechargeamount}></div>
                    <Input
                        placeholder={`${t("KLR02567")} ${parentCurrencySymbol}`}
                        label={`${t("KLR02567")} ${parentCurrencySymbol}`}
                        type='text'
                        value={creditAmount}
                        showBottomLabelSpace={false}
                        bottomLabelType={creditAmountErr ? validateFields('creditAmount') : undefined}
                        bottomLabel={creditAmountErr ? setErrors('creditAmount') : null}
                        onChange={(e: any) => {
                            setCreditAmountErr('');
                            setCreditAmount(e.target.value);
                        }}
                        onBlur={() => {
                            handleCreditAmountOnBlur();
                        }}
                    />
                </div>
                <p className={Styles.deduct}>{t("KLR02542")}</p>
            </>
        )
    }

    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={sidebarVisibility}
            footer={getFooter()}
            title={t("KLR02568")}
        >
            {getContent()}

        </Slider>
    );
};

export default RechargeSubAccount;
